import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import useStore from '@/store';
import { isExternal } from '@/utils/validate';
import SidebarLogo from './SidebarLogo.vue';
import SidebarItem from './SidebarItem.vue';

import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const activeMenu = computed(() => {
      const {
        meta,
        path
      } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    });
    const showLogo = computed(() => store.setting.sidebarLogo);
    const isCollapse = computed(() => store.app.sidebar.opened);
    const permission_routes = computed(() => store.permission.routes);
    function menuSelect(index) {
      //index是否包含external
      if (isExternal(index)) {
        window.open(index);
        return;
      }
      router.push(index);
    }
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'has-logo': showLogo.value
        }),
        style: {
          "display": "flex",
          "flex-direction": "column"
        }
      }, [showLogo.value ? (_openBlock(), _createBlock(SidebarLogo, {
        key: 0,
        collapse: isCollapse.value
      }, null, 8, ["collapse"])) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
        class: "menu-scroll",
        "wrap-class": "scrollbar-wrapper",
        style: _normalizeStyle({
          height: showLogo.value ? 'calc(100vh - 50px)' : '100vh'
        })
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          collapse: isCollapse.value,
          class: "app-el-menu-vertical",
          onSelect: menuSelect
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission_routes.value, route => {
            return _openBlock(), _createBlock(SidebarItem, {
              key: route.path,
              item: route,
              "base-path": route.path
            }, null, 8, ["item", "base-path"]);
          }), 128))]),
          _: 1
        }, 8, ["default-active", "collapse"])]),
        _: 1
      }, 8, ["style"])], 2);
    };
  }
});